<template>
  <div class="page flex-col">
    <!-- 骨架屏：文章详情页占位 -->
    <transition name="detail-skeleton-fade">
      <div v-if="showSkeleton" class="detail-skeleton">
        <div class="ds-wrap">
          <!-- 顶部导航区 -->
          <div class="ds-header"></div>
          <!-- 主体双栏 -->
          <div class="ds-body">
            <!-- 左侧 -->
            <div class="ds-left">
              <div class="ds-article-title"></div>
              <div class="ds-article-meta"></div>
              <div class="ds-article-content" v-for="i in 4" :key="'c' + i"></div>
              <div class="ds-comment-title"></div>
              <div class="ds-comment-row" v-for="i in 3" :key="'cm' + i">
                <div class="ds-comment-avatar"></div>
                <div class="ds-comment-text">
                  <div class="ds-comment-line"></div>
                  <div class="ds-comment-line short"></div>
                </div>
              </div>
              <div class="ds-recommend-row">
                <div class="ds-recommend-card" v-for="i in 4" :key="'r' + i">
                  <div class="ds-rc-img"></div>
                  <div class="ds-rc-line"></div>
                  <div class="ds-rc-line short"></div>
                </div>
              </div>
            </div>
            <!-- 右侧 -->
            <div class="ds-right">
              <div class="ds-sidebar-block"></div>
              <div class="ds-sidebar-block tall"></div>
              <div class="ds-sidebar-ad"></div>
              <div class="ds-sidebar-ad"></div>
            </div>
          </div>
          <!-- 合作品牌栏 -->
          <div class="ds-brands"></div>
          <!-- 底部 -->
          <div class="ds-footer"></div>
        </div>
      </div>
    </transition>

    <div class="block_9 flex-row">
      <div class="box_63 flex-col">
        <!-- 头部：顶部通栏 + 品牌栏 + 导航栏 -->
        <PageHeader :category-id="articleCategoryId" />
        <!-- 主体内容：文章 + 评论 + 推荐 + 右侧栏 + 合作品牌 -->
        <PageMain ref="pageMain" @open-login="showLogin = true" @category-loaded="onCategoryLoaded" />
        <!-- 尾部：社交媒体 + 政务服务 + 版权 -->
        <PageFooter />
      </div>
    </div>

    <!-- 登录弹窗 -->
    <Login
      v-if="showLogin"
      modal-mode
      @close="showLogin = false"
      @login-success="onLoginSuccess"
      @switch-register="switchToRegister"
    />

    <!-- 注册弹窗 -->
    <Register
      v-if="showRegister"
      modal-mode
      @close="showRegister = false"
      @register-success="onLoginSuccess"
      @switch-login="switchToLogin"
    />
  </div>
</template>

<script>
import PageHeader from './components/PageHeader.vue'
import PageMain from './components/PageMain.vue'
import PageFooter from './components/PageFooter.vue'
import Login from '../pages/Login.vue'
import Register from '../pages/Register.vue'

import './assets/css/common.css'
import './assets/css/header.css'
import './assets/css/content.css'
import './assets/css/footer.css'

export default {
  name: 'LanhuNewXiangQingYeMian1',
  components: {
    PageHeader,
    PageMain,
    PageFooter,
    Login,
    Register
  },
  data() {
    return {
      showSkeleton: true,
      showLogin: false,
      showRegister: false,
      articleCategoryId: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.showSkeleton = false
      }, 800)
    })
  },
  methods: {
    onCategoryLoaded(categoryId) {
      this.articleCategoryId = categoryId
    },
    onLoginSuccess() {
      // 关闭弹窗并重新加载用户信息，然后聚焦评论输入框
      this.showLogin = false
      this.showRegister = false
      this.$nextTick(() => {
        this.$refs.pageMain.fetchUserInfo()
        this.$refs.pageMain.focusComment()
      })
    },
    switchToRegister() {
      this.showLogin = false
      this.showRegister = true
    },
    switchToLogin() {
      this.showRegister = false
      this.showLogin = true
    }
  }
}
</script>

<style scoped>
/* 骨架屏 */
.detail-skeleton {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;
  overflow-y: auto;
}
.ds-wrap {
  width: 1400px;
  margin: 0 auto;
  padding: 14px 0 40px;
}
.detail-skeleton-fade-leave-active {
  transition: opacity 0.4s ease;
}
.detail-skeleton-fade-leave-to {
  opacity: 0;
}
/* shimmer 基础样式 */
.ds-header,
.ds-article-title,
.ds-article-meta,
.ds-article-content,
.ds-comment-title,
.ds-comment-avatar,
.ds-comment-line,
.ds-rc-img,
.ds-rc-line,
.ds-sidebar-block,
.ds-sidebar-ad,
.ds-brands,
.ds-footer {
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
  background-size: 200% 100%;
  animation: ds-shimmer 1.6s infinite linear;
  border-radius: 4px;
}
@keyframes ds-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
/* 顶部导航 */
.ds-header {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
}
/* 主体双栏 */
.ds-body {
  display: flex;
  gap: 35px;
  margin-bottom: 20px;
}
.ds-left {
  width: 1042px;
  flex-shrink: 0;
}
.ds-right {
  width: 323px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
/* 文章区域 */
.ds-article-title {
  width: 80%;
  height: 40px;
  margin-bottom: 16px;
}
.ds-article-meta {
  width: 60%;
  height: 20px;
  margin-bottom: 24px;
}
.ds-article-content {
  width: 100%;
  height: 24px;
  margin-bottom: 14px;
}
/* 评论区 */
.ds-comment-title {
  width: 200px;
  height: 24px;
  margin: 30px 0 20px;
}
.ds-comment-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}
.ds-comment-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
}
.ds-comment-text {
  flex: 1;
}
.ds-comment-line {
  width: 100%;
  height: 16px;
  margin-bottom: 8px;
}
.ds-comment-line.short {
  width: 60%;
}
/* 推荐新闻 */
.ds-recommend-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 30px;
}
.ds-recommend-card {
  width: 245px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ds-rc-img {
  width: 100%;
  height: 140px;
}
.ds-rc-line {
  width: 100%;
  height: 16px;
}
/* 右侧栏 */
.ds-sidebar-block {
  width: 100%;
  height: 200px;
}
.ds-sidebar-block.tall {
  height: 300px;
}
.ds-sidebar-ad {
  width: 100%;
  height: 107px;
}
/* 合作品牌栏 */
.ds-brands {
  width: 100%;
  height: 160px;
  margin-bottom: 20px;
}
/* 底部 */
.ds-footer {
  width: 100%;
  height: 200px;
}
</style>
